import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  download: {
    id: 'views.PressRoomArticleView.PressRoomArticle.FileToDownload.download',
    defaultMessage: 'pobierz'
  }
});



// WEBPACK FOOTER //
// ./src/common/components/FileToDownload/FileToDownload.intl.js